import { Component, OnInit } from '@angular/core';
import { StationService } from '../../../services/stations.service';
import { ActivatedRoute, Router } from '@angular/router';
import InitData from './data'
import { LocalDataSource } from 'ng2-smart-table';
import { ValidateOpenOptionComponent } from './validate-open-option/validate-open-option.component';
import { RecordSgm } from './data';
import { SgmService } from '../../../services/sgm/sgm.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SysUsersService } from '../../../services/sys-users.service';
import * as moment from 'moment';

@Component({
  selector: 'ngx-sgm',
  templateUrl: './sgm.component.html',
})
export class SgmComponent implements OnInit {
  files: Array<RecordSgm> = [];
  loading: boolean = false;
  stationId: string;
  source: LocalDataSource;
  itemsHistoryTable = [
    'anexo-4',
    'procedimiento-1',
    'procedimiento-2',
    'procedimiento-3',
    'procedimiento-4',
    'procedimiento-5',
    'procedimiento-6',
    'procedimiento-7',
    'procedimiento-8',
    'procedimiento-9',
    'procedimiento-10',
    'procedimiento-11',
    'procedimiento-12',
    'procedimiento-13',
    'procedimiento-14',
    'procedimiento-15',
    'manual-1'
  ]
  show: 'init' | 'detail' = 'init'
  category: 'anexos' | 'formatos' | 'manual' | 'procedimientos' = 'anexos'
  anexos: RecordSgm[] = [];
  formatos: RecordSgm[] = [];
  manual: RecordSgm[] = [];
  procedimientos: RecordSgm[] = [];
  record: RecordSgm = {
    key: '',
    name: '',
    rows: [],
    category: '',
    type: 'download'
  }

  settings: any = {
    mode: 'external',
    actions: false,
    pager: { perPage: 50 },
    columns: {
      // category: { title: 'Categoría', filter: true },
      name: { title: 'Documento', filter: true },
      actions: {
        add: false,
        edit: false,
        delete: false,
        filter: false,
        title: '',
        type: 'custom',
        valuePrepareFunction: (cell, row) => row,
        renderComponent: ValidateOpenOptionComponent,
        onComponentInitFunction: (instance) => {
          instance.openDetail.subscribe(event => {
            this.onCustomImplementation(event);
          });
        },
      },
    },
    noDataMessage: 'Sin registros',
  };
  user = { role: '' }
  year = moment().year()

  constructor(
    private sgmService: SgmService,
    private stationService: StationService,
    private route: ActivatedRoute,
    private userService: SysUsersService,
  ) {
    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
    });
  }

  ngOnInit() {
    this.stationService.checkIfStationIdOrRefirect();
    this.stationId = this.route.snapshot.params.stationId;
    this.setUser()
    this.getFiles();
  }

  async setUser () {
    const [error, response] = await this.userService.getProfileV2();
    if (error) return error;
    this.user = response.data;
    if (this.user.role === 'viewAndDownloadOnly') {
      this.settings.actions.custom = [];
    }
  }

  async getFiles() {
    this.anexos = InitData.anexos
    this.formatos = InitData.formatos
    this.manual = InitData.manual
    this.procedimientos = InitData.procedimientos
    this.changeCategory(this.category)
    this.loading = false;
  }

  formatData (baseData: RecordSgm[], savedData: RecordSgm[]) {
    return baseData.map(item => {
      const saved = savedData.find(saved => saved.key === item.key);
      if (saved) item.rows = saved.rows
      return item;
    })
  }

  async changeCategory (category: 'anexos' | 'formatos' | 'manual' | 'procedimientos') {
    if (category === 'anexos') { this.source = new LocalDataSource(this.anexos) }
    if (category === 'formatos') { this.source = new LocalDataSource(this.formatos) }
    if (category === 'manual') { this.source = new LocalDataSource(this.manual) }
    if (category === 'procedimientos') { this.source = new LocalDataSource(this.procedimientos) }
  }

  async onCustomImplementation(rowData: RecordSgm) {
    this.loading = true;
    const [error, response] = await this.sgmService.getByStationIdAndKey(this.stationId, rowData.key, this.year);
    this.loading = false;
    if (error) {
      return this.alert('Oops, Intenta más tarde', 'error');
    }

    this.record = { ...rowData, rows: response.data.map(row => ({ ...row.data, id: row.id })) };
    if (rowData.type === 'form') this.show = 'detail'
    else {
      await this.sgmService.downloadFormat({
        stationId: this.stationId,
        category: rowData.category.toLowerCase(),
        file: rowData.key,
        id_item: ''
      });
    }
  }

  async recordChange (record: RecordSgm & { row: any, event: string }) {
    this.loading = true;
    if (record.event === 'create') {
      const [error] = await this.sgmService.create(
        this.stationId,
        {
          key: record.key,
          category: record.category,
          data: record.row,
          year: this.year
        }
      )
      this.loading = false;
      if (error) return this.alert('Oops, intenta más tarde', 'error');
    } else if (record.event === 'edit') {
      const [error] = await this.sgmService.update(record.row.id, { data: record.row })
      this.loading = false;
      if (error) return this.alert('Oops, intenta más tarde', 'error');
    } else if (record.event === 'delete') {
      const [error] = await this.sgmService.delete(record.row.id)
      this.loading = false;
      if (error) return this.alert('Oops, intenta más tarde', 'error');
    }
    await this.onCustomImplementation(this.record)
    this.loading = false;
    return this.alert('Operación realzada con éxito', 'success');
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
